import React, { useState, useRef, useEffect } from "react";
import RegisterStep1 from "./component/RegisterStep1";
import RegisterStep2 from "./component/RegisterStep2";
import RegisterStep3 from "./component/RegisterStep3";
import RegisterStep2bis from "./component/RegisterStep2bis";
import { categories } from "./component/category";

const Register = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [openingHours, setOpeningHours] = useState(null);

  const step2Ref = useRef(null);
  const step2bisRef = useRef(null);
  const step3Ref = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleStep1Next = (service) => {
    setSelectedService(service);
    setTimeout(
      () => step2Ref.current?.scrollIntoView({ behavior: "smooth" }),
      300
    );
  };

  const selectedCategory = categories.find(
    (cat) => cat.label === selectedService
  );
  const needOpeningHours = selectedCategory?.needHours === true;

  const handleStep2Next = (staffCount) => {
    setSelectedStaff(staffCount);

    if (needOpeningHours) {
      setTimeout(
        () => step2bisRef.current?.scrollIntoView({ behavior: "smooth" }),
        300
      );
    } else {
      setTimeout(
        () => step3Ref.current?.scrollIntoView({ behavior: "smooth" }),
        300
      );
    }
  };

  const handleStep2bisNext = (schedule) => {
    setOpeningHours(schedule);
    setTimeout(
      () => step3Ref.current?.scrollIntoView({ behavior: "smooth" }),
      300
    );
  };

  const handleStep3Submit = (formData) => {
    const adminType = needOpeningHours ? 1 : 2;
    const payload = {
      service: selectedService,
      staffCount: selectedStaff,
      adminType,
      ...formData,
    };

    if (needOpeningHours) {
      payload.openingHours = openingHours;
    }
    console.log("Full Payload:", payload);
  };

  return (
    <div>
      <RegisterStep1 onNext={handleStep1Next} />
      {selectedService && (
        <div ref={step2Ref}>
          <RegisterStep2 onNext={handleStep2Next} />
        </div>
      )}
      {selectedService && selectedStaff && needOpeningHours && (
        <div ref={step2bisRef}>
          <RegisterStep2bis onNext={handleStep2bisNext} />
        </div>
      )}
      {selectedService &&
        selectedStaff &&
        (!needOpeningHours || openingHours) && (
          <div ref={step3Ref}>
            <RegisterStep3 onSubmit={handleStep3Submit} />
          </div>
        )}
    </div>
  );
};

export default Register;
